const SortAscending = () => (
  <>
    <path
      fill="currentColor"
      d="M11.5 17a.5.5 0 1 1 0-1h1.75a.5.5 0 0 1 0 1zm0-4.5a.5.5 0 1 1 0-1h5.366a.5.5 0 0 1 0 1zm0-4.5a.5.5 0 1 1 0-1h9a.5.5 0 0 1 0 1zM6.616 16.44l1.078-1.077a.43.43 0 0 1 .327-.14.48.48 0 0 1 .345.146q.138.134.137.34a.47.47 0 0 1-.14.348l-1.681 1.7a.78.78 0 0 1-.566.243.78.78 0 0 1-.565-.242l-1.7-1.7a.464.464 0 0 1 0-.674.46.46 0 0 1 .34-.137q.207 0 .348.14l1.077 1.053V6.5q0-.213.144-.356A.49.49 0 0 1 6.117 6q.213 0 .356.144a.49.49 0 0 1 .143.356z"
    />
  </>
)
export default SortAscending
